import axios from "axios";

export const processJimpiFile = async (filename: string): Promise<void> => {
        const response = await axios.post(`/booking/import/processJimpiFile/${filename}`, null);
        return response.data;
    };


export default processJimpiFile;
